import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { getFollowedProfiles, toggleFollowProfile } from "../api";

export default function FollowButton({ profileId, small = false }) {
  const [isFollowing, setIsFollowing] = useState(
    getFollowedProfiles().includes(profileId)
  );

  useEffect(() => {
    const handler = () =>
      setIsFollowing(getFollowedProfiles().includes(profileId));
    window.addEventListener("followChanged", handler);
    return () => window.removeEventListener("followChanged", handler);
  }, [profileId]);

  return (
    <Button
      size={small ? "small" : "medium"}
      variant={isFollowing ? "outlined" : "contained"}
      sx={{
        textTransform: "none",
        ml: small ? 1 : 2,
        px: small ? 1.25 : 2,
        borderRadius: 9999,
        minWidth: small ? 68 : 96,
      }}
      onClick={(e) => {
        e.preventDefault(); // don't trigger parent <Link>
        toggleFollowProfile(profileId);
      }}
    >
      {isFollowing ? "Following" : "Follow"}
    </Button>
  );
}
